"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const reusables_1 = require("../../../../comps/reusables");
const constants_1 = require("../../../../constants");
const graphql_1 = require("../../../../graphql");
const react_2 = require("@osmosys/react");
exports.Settings = props => {
    const agreedToTermsOfService = !!(props.workspace.agreedToTermsOfServiceUser &&
        props.workspace.agreedToTermsOfServiceDate);
    return (react_1.default.createElement(react_2.OsmosysSmallContainer, null,
        react_1.default.createElement(reusables_1.Form, { formikProps: {
                initialValues: {
                    agreedToTermsOfService,
                    archived: props.workspace.archived,
                    dashboardUrls: props.workspace.dashboardUrls,
                    enabledIntegrationClasses: props.workspace.enabledIntegrationClasses.map(cls => constants_1.INTEGRATION_OPTIONS.find(opt => opt.value === cls)),
                    enableSubscriberTools: props.workspace.enableSubscriberTools,
                    helpLink: props.workspace.helpLink || '',
                    isUserAnalyticsEnabled: props.workspace.isUserAnalyticsEnabled,
                    isWorkspaceAnalyticsEnabled: props.workspace.isWorkspaceAnalyticsEnabled,
                    name: props.workspace.name,
                },
            }, mutationProps: {
                mutation: graphql_1.updateWorkspace,
                refetchQueries: [
                    {
                        query: graphql_1.currentUser,
                    },
                ],
            }, valuesToVariables: values => ({
                data: {
                    agreedToTermsOfService: values.agreedToTermsOfService === true,
                    archived: values.archived,
                    dashboardUrls: values.dashboardUrls,
                    enabledIntegrationClasses: values.enabledIntegrationClasses.map(opt => opt.value),
                    enableSubscriberTools: values.enableSubscriberTools,
                    helpLink: values.helpLink || '',
                    isUserAnalyticsEnabled: values.isWorkspaceAnalyticsEnabled &&
                        values.isUserAnalyticsEnabled,
                    isWorkspaceAnalyticsEnabled: values.isWorkspaceAnalyticsEnabled,
                    name: values.name,
                },
                id: props.workspace.id,
            }), showBottomToolbar: true }, () => (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(reusables_1.FormGroup, { label: "Name", type: "text", name: "name" }),
                react_1.default.createElement("div", { className: "mt-4" },
                    react_1.default.createElement(reusables_1.FormGroup, { label: react_1.default.createElement(react_1.default.Fragment, null,
                            "Terms of service agreed to",
                            react_1.default.createElement("a", { href: "https://yellowbrim.com/agreement/", target: "_blank", className: "ml-2", rel: "noopener noreferrer" },
                                "Terms of service",
                                ' ',
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faExternalLinkSquare }))), type: "checkbox", options: constants_1.INTEGRATION_OPTIONS, name: "agreedToTermsOfService", disabled: !!(props.workspace.agreedToTermsOfServiceUser &&
                            props.workspace.agreedToTermsOfServiceDate) }),
                    react_1.default.createElement(react_if_1.When, { condition: agreedToTermsOfService }, () => (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", null,
                            "Agreed to by",
                            ' ',
                            react_1.default.createElement("strong", null,
                                react_1.default.createElement(react_2.OsmosysTooltip, { span: true, label: props.workspace.agreedToTermsOfServiceUser.email }, props.workspace.agreedToTermsOfServiceUser
                                    .fullName ||
                                    props.workspace.agreedToTermsOfServiceUser.email)),
                            ' ',
                            "on",
                            ' ',
                            react_1.default.createElement("strong", null,
                                react_1.default.createElement(react_moment_1.default, { format: "LLL" }, props.workspace.agreedToTermsOfServiceDate)))))))))))));
};
//# sourceMappingURL=Settings.js.map